import type { Action } from 'redux';
import NotificationActions from '../../../../../main/actions/NotificationActions';
import dash_api from '../../../../../main/support/dash_api';
import type { Rule } from '../../../../../main/types/journeyTypes';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { ActionNamespaceConstants } from '../../../../types/ReduxAsyncActions.types';

type APIResponseType = {
  audience_rules: Rule[];
};

type ActionResponseType = Rule[];

const FetchJourneyIterations = new ReduxAsyncAction<'FETCH_JOURNEY_ITERATIONS', string, ActionResponseType>(
  'FETCH_JOURNEY_ITERATIONS'
);

FetchJourneyIterations.registerRequest(async (journeyId: string) => {
  try {
    const { data } = await dash_api.get<APIResponseType>(`/v1/audience_rule/${journeyId}/versions`);
    return data.audience_rules;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch Journey history report', 'error');
    throw error;
  }
});

export const FETCH_JOURNEY_ITERATIONS = FetchJourneyIterations.actionNamespaceConstants;

export const fetchJourneyIterations = FetchJourneyIterations.request;

type ActionType = ActionNamespaceConstants<'FETCH_JOURNEY_ITERATIONS'>;

export type FetchJourneyIterationsResponseAction = Action<ActionType | string> & { data: Rule[] };
